module.exports = __webpack_public_path__ + "media/images/front/dr_kizu_y-ce03dd208aa14fa465f0cefa5d0e889a.jpg";